import '../SASS/about.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import SocialLink from '../components/SocialLink'
import avatar from '../Assets/img/avatar5.png'

const About = () => {
  return (
    <section className="about">
      <div className="about-nav">
        <Link exact="true" to="/" className="home-arrow">
          Home <FontAwesomeIcon icon={faArrowRight} />
        </Link>
        <div className="line"></div>
        <Link to="/work" className="portfolio-arrow">
          <FontAwesomeIcon icon={faArrowLeft} />
          Work
        </Link>
      </div>
      <article className="about-flex">
        <div className="about-section">
          <h2 className="heading">Hello.</h2>
          <p>
            My name is Ishan, I'm a Frontend Web Developer building the
            Front-end of Websites and Web Applications that leads to the success
            of the overall product. Check out some of my work in the
            <Link to="/work">Project</Link> section.
          </p>
          <p className="pera">
            I'm open to Job opportunities where I can contribute, learn and
            grow. If you have a good opportunity that matches my skills and
            experience then don't hesitate to contact me.
          </p>
          <Link to="/contact" className="contact-btn">
            contact me
          </Link>
        </div>
        <div className="img-container">
          <img src={avatar} alt="" />
        </div>
      </article>
      <div className="social-link">
        <SocialLink />
      </div>
      <div className="about-svg">
        <svg
          width="1278"
          height="263"
          viewBox="0 0 1278 263"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M74.6193 259H0.0454543L126.324 4.45454H220.784L262.545 259H187.972L163.114 74.554H161.125L74.6193 259ZM77.6023 158.574L217.801 158.574L208.852 210.278H68.6534L77.6023 158.574ZM287.062 259L329.32 4.45454L439.689 4.45454C459.079 4.45454 474.946 7.06463 487.292 12.2848C499.721 17.505 508.505 24.8795 513.642 34.4084C518.862 43.9373 520.395 55.1648 518.241 68.0909C516.583 77.3712 513.02 85.8643 507.552 93.5703C502.166 101.193 495.33 107.656 487.044 112.96C478.841 118.18 469.685 121.784 459.576 123.773L459.079 126.259C470.016 126.59 479.545 129.324 487.665 134.462C495.786 139.516 501.751 146.559 505.563 155.591C509.375 164.54 510.286 174.98 508.297 186.912C505.977 200.832 500.301 213.22 491.27 224.075C482.238 234.929 470.513 243.464 456.096 249.678C441.678 255.893 425.272 259 406.877 259L287.062 259ZM365.613 203.815H397.928C409.363 203.815 418.353 201.62 424.899 197.228C431.528 192.836 435.464 186.415 436.707 177.963C437.701 171.997 437.204 166.943 435.215 162.8C433.226 158.657 429.871 155.508 425.148 153.354C420.425 151.199 414.5 150.122 407.374 150.122H374.064L365.613 203.815ZM381.522 107.366H409.86C415.826 107.366 421.295 106.414 426.266 104.508C431.238 102.602 435.339 99.8262 438.571 96.1804C441.802 92.5346 443.832 88.143 444.661 83.0057C445.904 75.0511 443.998 69.0024 438.944 64.8594C433.972 60.7164 427.26 58.6449 418.809 58.6449H389.476L381.522 107.366ZM787.825 136.202C783.185 163.877 773.988 187.078 760.233 205.804C746.478 224.53 729.782 238.658 710.144 248.187C690.506 257.716 669.501 262.48 647.129 262.48C623.265 262.48 602.55 257.301 584.984 246.944C567.418 236.586 554.616 221.423 546.579 201.454C538.541 181.485 536.925 157.082 541.731 128.247C546.206 100.572 555.32 77.2883 569.075 58.3963C582.83 39.5043 599.609 25.2109 619.412 15.5163C639.216 5.82173 660.387 0.974422 682.925 0.974422C706.622 0.974422 727.213 6.19459 744.697 16.6349C762.263 27.0753 775.023 42.3629 782.978 62.4979C791.015 82.6328 792.631 107.201 787.825 136.202ZM718.223 128.247C720.543 113.664 720.709 101.401 718.72 91.4574C716.731 81.4313 712.547 73.8911 706.167 68.8366C699.787 63.6993 691.211 61.1307 680.439 61.1307C668.175 61.1307 657.321 64.1136 647.875 70.0795C638.429 76.0454 630.599 84.6214 624.384 95.8075C618.17 106.994 613.819 120.458 611.334 136.202C608.682 150.951 608.434 163.214 610.588 172.991C612.825 182.769 617.217 190.102 623.763 194.991C630.391 199.879 639.009 202.324 649.615 202.324C661.712 202.324 672.401 199.424 681.682 193.624C691.045 187.823 698.792 179.413 704.924 168.393C711.138 157.372 715.571 143.991 718.223 128.247ZM992.313 4.45454H1061.42L1034.32 167.523C1031.17 186.912 1023.8 203.691 1012.2 217.86C1000.68 231.946 986.016 242.842 968.201 250.548C950.386 258.171 930.582 261.983 908.79 261.983C886.832 261.983 868.272 258.171 853.108 250.548C837.945 242.842 826.925 231.946 820.047 217.86C813.253 203.691 811.43 186.912 814.578 167.523L841.674 4.45454H910.779L884.678 161.557C883.435 169.429 884.056 176.43 886.542 182.562C889.028 188.693 893.047 193.541 898.598 197.104C904.15 200.584 910.862 202.324 918.733 202.324C926.688 202.324 934.021 200.584 940.733 197.104C947.527 193.541 953.162 188.693 957.636 182.562C962.11 176.43 964.969 169.429 966.212 161.557L992.313 4.45454ZM1077.86 60.1364L1087.3 4.45454L1308.54 4.45454L1299.09 60.1364H1222.53L1189.72 259H1121.61L1154.42 60.1364H1077.86Z"
            fill="white"
            fill-opacity="0.05"
          />
        </svg>
      </div>
      <div className="me-svg">
        <svg
          width="688"
          height="328"
          viewBox="0 0 688 328"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M55.3224 0.727263L140.656 0.727263L194.509 220.614H198.344L324.747 0.727263L410.081 0.727263L355.749 328H288.632L324.108 114.985H321.232L201.7 326.402H155.837L106.619 114.186H103.902L68.1065 328H0.990057L55.3224 0.727263ZM412.758 328L467.09 0.727263L687.616 0.727263L678.028 57.7763H526.696L513.912 135.759H653.898L644.309 192.808H504.324L491.54 270.951H643.51L633.922 328H412.758Z"
            fill="white"
            fill-opacity="0.05"
          />
        </svg>
      </div>
    </section>
  )
}

export default About
